module.exports = __webpack_public_path__ + "img/logo.17ba0bb9.jpeg";